import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { PageSpinner, ServerError } from '@ohpen/enso-ui';
import type { IConfig } from '@ohpen/react-utils';

import './styles.css'; // TODO: move to Enso UI
import './i18n';
import { App } from './App';

// Configure dayjs plugins globally
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export async function bootstrap() {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Root element with id "root" not found in the document.');
  }

  const root = createRoot(container);

  // Show loading spinner while fetching config
  root.render(
    <StrictMode>
      <PageSpinner />
    </StrictMode>,
  );

  try {
    // Load config before rendering app
    const response = await fetch('/config/config.json');

    if (!response.ok) {
      throw new Error(`Failed to load config: HTTP ${response.status}`);
    }

    const config: IConfig = await response.json();

    if (config.HARNESS_MODE) {
      const host = globalThis.location.hostname;
      if (host !== 'localhost' && host !== '127.0.0.1') {
        throw new Error(
          `HARNESS_MODE is enabled in config.json but the app is served from '${host}'. ` +
            `Harness auth bypass must only run on localhost. Refusing to mount.`,
        );
      }
    }

    // Render the app with config
    root.render(
      // <StrictMode>
      <App config={config} />,
      // </StrictMode>,
    );
  } catch (error) {
    console.error('Failed to bootstrap application:', error);
    root.render(
      <StrictMode>
        <ServerError />
      </StrictMode>,
    );
  }
}
